var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{staticClass:"my-6 mx-auto",staticStyle:{"max-width":"1500px"}},[_c('v-card',[_c('v-card-text',{staticClass:"px-0 py-0"},[(_vm.selectedClassGroup)?_c('ClassGroupCalendary',{attrs:{"zClassGroup":_vm.selectedClassGroup,"onlyAllowedLesson":null,"readable":true,"forStudent":true}}):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }